import styled from 'styled-components';
import MoneyIconDark from '../../assets/images/money-icon.svg';
import MoneyIconLight from '../../assets/images/money-icon-light.svg';

const MoneyIcon = styled.span`
    background: ${(props) =>
      props.theme.palette.type === 'dark'
        ? `url("${MoneyIconDark}") no-repeat left center`
        : `url("${MoneyIconLight}") no-repeat left center`};
    background-size: 34px 27px;
    display: inline-block;
    position: relative;
    vertical-align: middle;
    height: 27px;
    width: 34px;
}`;

export default MoneyIcon;
